<template>
    <div>
        <div class="main-content-container container-fluid px-4">
            <div class="page-header row no-gutters pt-4 pb-2">
                <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
                    <span class="text-uppercase page-subtitle">DEMANDE DE CONTRAT</span>
                </div>
            </div>
            <div class="row flex pb-2">
                <div class="col-12">
                    <h5 class="float-left font-weight-bold mb-0">
                        Employé | {{ request.lastName }} {{ request.firstName }}
                    </h5>
                    <div class="col-12 mt-5">
                        <button class="btn btn-outline wizard-btn return-btn float-left" @click="backToList()">
                            <i class="fa fa-arrow-left" aria-hidden="true"></i>
                            {{ $t("global.return") }}
                        </button>
                        <button class="btn btn-primary wizard-btn next-btn float-right" @click="goToNewContract()"
                        v-if="!this.$store.state.user.informations.permissions.some(permission => permission.groupReference == '_animateur')">
                            NOUVELLE DEMANDE CDD PEC, CDI, BÉNÉVOLE
                        </button>
                        <button class="btn btn-primary wizard-btn next-btn float-right mr-2"
                            @click="goToNewContract('CEE')">
                            Nouvelle Demande CEE
                        </button>
                        <button v-if="edit" class="btn btn-danger next-btn float-right mr-3 px-7" @click="cancelEditing()">
                            Annuler
                        </button>
                        <button v-if="this.$store.state.user.informations.permissions[0]
                                .groupReference == '_super_admin'
                            " class="btn btn-warning next-btn float-right mr-3" @click="editDemand()">
                            {{ edit ? "Confirmer" : "Modifier" }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="mb-4 pb-5">
                <loading-spinner v-if="loading" :isLoading="loading" />
                <template v-else>
                    <div class="card d-inline float-right d-flex justify-content-center mr-5">
                        <div class="CEE-counter mx-3 my-5 d-flex flex-column justify-content-center">
                            <d-input v-if="edit" type="text" v-model="request.daysOfContract" class="mb-5" />
                            <div v-else class="text-center font-weight-bold" style="font-size: 30px">
                                {{ request.daysOfContract }}
                            </div>
                            <div class="text-center font-weight-bold" style="font-size: 15px; margin-top: -15px">
                                Jours
                            </div>
                            <div class="text-center" style="font-size: 10px; color: gray">
                                COMPTEUR CEE (à titre indicatif)
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4 col-6">
                        <div class="card-body p-4">
                            <h5 class="header-data-table__heading">
                                Informations personnelles
                            </h5>
                            <div class="row py-5 px-5">
                                <template class="my-5">
                                    <recapitulatif-employee :request="request" :edit="edit"
                                        :show-last-two="false" />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="card">
                                <div class="header-data-table">
                                    <h5 class="header-data-table__heading">
                                        Précédents contrats
                                    </h5>
                                </div>
                                <div class="table-responsive pb-3">
                                    <table class="custom-table table t-responsive">
                                        <thead class="t-header-color">
                                            <tr class="text-center">
                                                <th>Type de contrat</th>
                                                <th>Structure</th>
                                                <th>Statut</th>
                                                <th>Date de début</th>
                                                <th>Date de fin</th>
                                                <th>Voir la demande</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(answer, idx) in preCont" :key="idx">
                                                <td>{{ contractType[answer.typeOfContract].name }}</td>
                                                <td>{{ answer.structureName }}</td>
                                                <td v-if="answer.status === 'ACCEPTED'">
                                                    <button class="status-pill-accepted">
                                                        <span>{{ $t("global.approved") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'PENDING'">
                                                    <button class="status-pill-pending">
                                                        <span>{{ $t("global.pending") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'REFUSED'">
                                                    <button class="status-pill-rejected">
                                                        <span>{{ $t("global.rejected") }}</span>
                                                    </button>
                                                </td>
                                                <td v-else-if="answer.status === 'TREATED'">
                                                    <button class="status-pill-approved">
                                                        <span>Contrat traité</span>
                                                    </button>
                                                </td>
                                                <td>
                                                    {{
                                                        answer.dateFrom
                                                        ? new Date(answer.dateFrom).toLocaleDateString(
                                                            "fr-FR"
                                                        )
                                                        : ""
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        answer.dateTo
                                                        ? new Date(answer.dateTo).toLocaleDateString(
                                                            "fr-FR"
                                                        )
                                                        : ""
                                                    }}
                                                </td>
                                                <td>
                                                    <button class="HistoryDemands-refuseButton" @click="goToDemand(answer.reference)"><i class="fa fa-eye" aria-hidden="true"></i></button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-4 col-6 mt-4">
                        <h5 class="header-data-table__heading">Documents</h5>
                        <div class="col-12">
                            <div class="row">
                                <div v-bind:class="{'col-4 px-1': !edit, 'col-6 px-1': edit}">
                                    <div class="document-container d-flex flex-column justify-content-center">
                                        <div class="document-inside-container">
                                            Pièce d'identité
                                        </div>
                                        <button class="document-download-button-employee"
                                            @click="downloadUpload(request.IDPath)">
                                            Télécharger
                                        </button>
                                    </div>
                                </div>
                                <div v-bind:class="{'col-4 px-1': !edit, 'col-6 px-1': edit}">
                                    <div class="document-container d-flex flex-column justify-content-center">
                                        <div class="document-inside-container">Carte vitale</div>
                                        <button class="document-download-button-employee"
                                            @click="downloadUpload(request.CVPath)">
                                            Télécharger
                                        </button>
                                    </div>
                                </div>
                                <div v-for="otherDoc in request.otherDocumentsPaths" v-bind:class="{'col-4 px-1': !edit, 'col-6 px-1': edit}">
                                    <file-upload v-if="edit" :document="otherDoc" />
                                    <div v-else class="document-container d-flex flex-column justify-content-center">
                                        <div class="document-inside-container">
                                            {{ otherDoc.name }}
                                        </div>
                                        <button class="document-download-button-employee"
                                            @click="downloadUpload(otherDoc.path)">
                                            Télécharger
                                        </button>
                                    </div>
                                </div>
                                <div class="py-3 px-1" v-if="edit">
                                    <button class="document-add-button" @click="addOtherDocument">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                        Ajouter un document
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import RecapitulatifEmployee from "../RecapitulatifEmployee.vue";
import contractType from "../../../data/contract/contractType";
import LoadingSpinner from "../../../components/shared/loadingSpinner";
import { storage } from "../../../firebase/app";
import FileUpload from "../../../components/shared/uploadFile.vue";
import {
    ref,
    uploadBytes,
    uploadBytesResumable,
    getDownloadURL,
    getBlob,
} from "firebase/storage";

export default {
    name: "StepOne",
    props: ["request", "originalRequest"],
    components: {
        RecapitulatifEmployee,
        LoadingSpinner,
        FileUpload
    },
    mounted() {
        localStorage.removeItem("model");
        this.$services.contractRequestService
            .findAllReqestsByEmail(this.request.email)
            .then(({ data }) => {
                this.preCont = data;
            });
    },
    data() {
        return {
            preCont: [],
            contractType,
            edit: false,
            loading: false,
        };
    },
    methods: {
        backToList() {
            this.$router.push(`/employeeManagement`);
        },
        async editDemand() {
            if (this.edit) {
                this.request.otherDocumentsPaths = this.request.otherDocumentsPaths.map((document) => {
                    const { showActionButtons, progress, ...rest } = document;
                    rest.showUploadComplete = false;
                    return rest;
                });
                await this.$services.employeeService
                    .editEmployee(this.request.reference, this.request)
                    .then((res) => {
                        // this.$router.push(`/employeeManagement`);
                        this.$router.go(0);
                        this.$miniToastr.success("Employee éditer avec succès");
                    })
                    .catch((e) => {
                        this.$miniToastr.error(
                            "Il y a eu une erreur lors de l'éditer d'employee'"
                        );
                    });
            }
            this.edit = !this.edit;
        },
        cancelEditing() {
            this.edit = false;
            this.request = JSON.parse(JSON.stringify(this.originalRequest));
        },
        goToNewContract(ContractType) {
            if (ContractType == "CEE") {
                this.$emit("input", "CEE");
            } else {
                this.$emit("input");
            }
        },
        goToDemand(reference) {
            this.$router.push(`/contracts/${reference}`);
        },
        addOtherDocument() {
            this.request.otherDocumentsPaths.push({
                name: `Autre document`,
                showDelete: true,
                showUploadComplete: false,
            });
        },
        handleDeletingOtherDocuments(doc) {
            console.log("from the handleDeletingOtherDocuments : ", doc);
            const index = this.request.otherDocumentsPaths.indexOf(doc);
            if (index > -1) {
                this.request.otherDocumentsPaths.splice(index, 1);
            }
        },
        downloadUpload(pathToFile) {
            this.loading = true;
            getDownloadURL(ref(storage, pathToFile))
                .then((url) => {
                    const xhr = new XMLHttpRequest();
                    xhr.responseType = "blob";
                    xhr.open("GET", url);
                    xhr.send();
                    xhr.onload = function () {
                        const blob = new Blob([xhr.response]);
                        const a = document.createElement("a");
                        a.href = URL.createObjectURL(blob);
                        a.download = pathToFile;
                        a.click();
                    };
                    this.loading = false;
                })
                .catch((error) => {
                    // Handle any errors
                    console.error(error);
                });
        },
    },
};
</script>

<style>
.CEE-counter {
    color: #303778;
}

.document-download-button-employee {
    background-color: #ffffff;
    margin: 10px 20px;
    color: #5a6169;
    padding: 10px;
    border-radius: 10px;
    text-align: center;
}

.status-pill-pending {
    border: 1px solid #ffb400;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    padding: 0;
}

.status-pill-pending span {
    display: block;
    width: 150px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(255, 180, 0, 0.24);
    color: #ffb400;
}

.status-pill-approved {
    border: 1px solid #17c671;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    padding: 0;
}

.status-pill-approved span {
    display: block;
    width: 150px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(23, 198, 113, 0.24);
    color: #17c671;
}

.status-pill-accepted {
    border: 1px solid #174bc6;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    padding: 0;
}

.status-pill-accepted span {
    display: block;
    width: 150px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: #c6e0fa;
    color: #174bc6;
}

.status-pill-rejected {
    border: 1px solid #c4183c;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    cursor: pointer;
    border-radius: 5px;
    padding: 0;
}

.status-pill-rejected span {
    display: block;
    width: 150px;
    border-radius: 5px;
    padding: 5px 15px;
    font-weight: 700;
    background-color: rgba(196, 24, 60, 0.24);
    color: #c4183c;
}

.HistoryDemands-refuseButton {
  border: 1px #ABB6BF solid;
  border-radius: 5px;
  color: #ABB6BF;
  padding: 5px 10px;
}

.document-add-button {
  border: 2px #4f78e2 dashed;
  border-radius: 15px;
  height: 100%;
  color: #4f78e2;
  padding: 10px;
}
</style>
